<template>
<div class="container pt-3" >
  <div class="row" >
    <div class="col-sm  d-flex justify-content-center text-center">
      <div class="card shadow-lg mb-3" style="max-width: 600px; margin-top:140px;">
        <div class="row g-0">
          <div class="col-md-4 bg-white">
              <br><br>
            <img src="../assets/password2.png" class="img-fluid rounded-start" alt="...">
          </div>
          <!-- CARD : User Logon -->
          <div class="col-md-8 bg-light">
            <div class="card-body bg-warning">
              <div class="card-title">
                <h5 class="text-white bg-danger rounded-pill p-2">Change Password</h5>
                <b>{{globalUserOfficialName}}</b>
              </div>
              <p class="card-text"><small class="text-muted">- ป้อนรหัสผ่านปัจจุบันและรหัสผ่านใหม่สองครั้ง -</small></p>
              <div class="row">
                <div class="input-group input-group-sm mb-2">
                  <span class="input-group-text " style="width:160px;">รหัสผ่านปัจจุบัน :</span>
                  <input type="password" class="form-control form-control-sm" ref="passwordOld" name="passwordOld" v-model="passwordOld">
                </div>
                <div class="input-group input-group-sm">
                  <span class="input-group-text " style="width:160px;">รหัสผ่านใหม่ (1) :</span>
                  <input type="password" class="form-control form-control-sm" ref="passwordNew1" name="passwordNew1" v-model="passwordNew1">
                </div>
                <div class="input-group input-group-sm">
                  <span class="input-group-text " style="width:160px;">รหัสผ่านใหม่ (2) :</span>
                  <input type="password" class="form-control form-control-sm" ref="passwordNew2" name="passwordNew2" v-model="passwordNew2">
                </div>
                <p class="mt-3 fs-6 text-light"> <i> Password อักษรตัวเล็กตัวใหญ่มีค่าต่างกัน</i></p>
              </div>
              <div class="row">
                  <div>
                    <button type="button" class="btn btn-danger float-sm-start btn-sm me-5" @click="backPage()"> Cancel</button>
                    <button type="button" class="btn btn-primary float-sm-end btn-sm" @click="checkUserPwdOK()">ตกลง</button>
                    <button type="button" class="btn btn-secondary btn-sm float-sm-end mx-2" @click="resetForm()">Reset</button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'UserChangepwd',
  data () {
    return {
      passwordOld: '',
      passwordNew1: '',
      passwordNew2: ''
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {
    backPage () {
      this.$router.push('/Home')
    },
    resetForm () {
      this.passwordOld = ''
      this.passwordNew1 = ''
      this.passwordNew2 = ''
      this.$refs.passwordOld.focus()
    },
    checkUserPwdOK () {
      if (this.passwordOld === '') {
        this.$refs.passwordOld.focus()
        Swal.fire({ icon: 'error', text: 'กรุณาป้อนรหัสผ่านปัจจุบัน' })
      } else if (this.passwordNew1 === '') {
        this.$refs.passwordNew1.focus()
        Swal.fire({ icon: 'error', text: 'กรุณาป้อนรหัสผ่านใหม่ครั้งที่1' })
      } else if (this.passwordNew2 === '') {
        this.$refs.passwordNew2.focus()
        Swal.fire({ icon: 'error', text: 'กรุณาป้อนรหัสผ่านใหม่ครั้งที่สอง' })
      } else if (!(this.passwordNew1 === this.passwordNew2)) {
        this.$refs.passwordNew2.focus()
        Swal.fire({ icon: 'error', text: 'รหัสผ่านใหม่สองครั้งต้องตรงกัน' })
      } else {
        this.changePassword()
      }
    },
    changePassword () {
      var self = this
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_userchgpwd.php',
        data: { UserID: self.globalUserID, PasswordOld: self.passwordOld, PasswordNew1: self.passwordNew1 },
        statusCode: {
          200: function () {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'เปลี่ยนรหัสผ่านเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.$router.push('/Home')
            })
          },
          204: function () {
            Swal.fire({ icon: 'error', text: 'ตรวจสอบรหัสผ่านปัจจุบัน..แล้วดำเนินการอีกครั้ง' })
          },
          404: function () {
            alert('server page not found')
          }
        }
      }).done(function () {
        self.resetForm()
      })
    }
  }
}
</script>
